import ChevronRightIcon from '@heroicons/react/outline/ChevronRightIcon'
import { useDecision } from '@optimizely/react-sdk'
import { matchPath, useLocation } from 'react-router'
import { Link } from 'react-router-dom'

import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

import { FeaturesList } from '../../../lib/optimizely/feature.list'
import { SidebarItem } from './sidebars'
import { TrialProgress } from './TrialProgress'

export const MainSidebarContent = ({
  sidebar,
  onSelect,
}: {
  sidebar: SidebarItem
  onSelect: (item: SidebarItem) => void
}) => {
  const location = useLocation()
  const [decisionCustomProfileFields] = useDecision(
    FeaturesList.CustomProfileFields,
  )

  const [decisionAuditLogs] = useDecision(FeaturesList.AuditLogs)

  return (
    <NavVertical className="px-3 pt-3 flex-grow">
      <NavVertical.Group className="flex-grow">
        <h3 className="px-2 mt-3 text-basicMain-900">{sidebar?.title}</h3>
        {sidebar?.description ? (
          <p className="px-2 text-sm text-basicMain-400">
            {sidebar?.description}
          </p>
        ) : null}
        <div className="pt-3 space-y-1 flex flex-col">
          {sidebar?.children?.map(item => {
            if (
              item.featureFlag === FeaturesList.CustomProfileFields &&
              !decisionCustomProfileFields.enabled
            )
              return null
            if (
              item.featureFlag === FeaturesList.AuditLogs &&
              !decisionAuditLogs.enabled
            )
              return null

            const active =
              item.path &&
              matchPath(location.pathname, {
                path: item.path,
                exact: item.exact ?? true,
                strict: false,
              })
            return (
              <NavVertical.Item
                key={item.path}
                active={!!active}
                as={item?.href ? 'a' : Link}
                to={item.path}
                href={item.href}
                leadingIcon={item.icon}
                trailingIcon={item.arrow && <ChevronRightIcon />}
                onClick={() => {
                  if (typeof onSelect === 'function') onSelect(item)
                }}
              >
                {item.title}
              </NavVertical.Item>
            )
          })}
        </div>
      </NavVertical.Group>
      <NavVertical.Group>
        <TrialProgress />
      </NavVertical.Group>
    </NavVertical>
  )
}
